import React from "react"

export { default as FaceDistinguishCallDetail } from './CallDetail'
export default ({children}: any) => (<>{children}</>)
